import { DsIcon } from '@ice-web-app/designSystem';
import { loadModuleNamespace } from '@ice-web-app/shared-i18n';
import { useGlobalStore, useSidebarStore } from '@ice-web-app/shared-store';
import { getCurrentEcosystemBasePath } from '@ice-web-app/shared-utils';
import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { satV1AR, satV1DE, satV1EN } from '../locales';
import { ZoneRoutes } from '../routes/ZoneRoutes';
import { routes } from '../routes/routes';

export const SatV1Zone: FC = () => {
  const { setMenuItems, setEntityMenuItems, setShowEntityMenu, setBackPath } = useSidebarStore();
  const { setShowMainSidebar } = useGlobalStore();
  const showMainSidebar = localStorage.getItem('showMainSidebar') === 'true';
  const location = useLocation();

  useEffect(() => {
    setShowMainSidebar(showMainSidebar);
  }, [showMainSidebar]);

  // Check if we are on an entity route
  useEffect(() => {
    const isEntityRoute = location.pathname.includes('/entity/');
    const entityIdMatch = location.pathname.match(/\/entity\/([^/]+)\//);
    const entityId = entityIdMatch ? entityIdMatch[1] : null;

    if (isEntityRoute && entityId) {
      // Show entity menu
      setShowEntityMenu(true);
      setEntityMenuItems([]);
    } else {
      // Show regular menu
      setShowEntityMenu(false);
      setEntityMenuItems([]);
    }
  }, [location.pathname]);

  useEffect(() => {
    setBackPath(getCurrentEcosystemBasePath() || '/');

    setMenuItems([
      {
        title: 'Upload Data Management',
        icon: <DsIcon icon="UPLOAD" />,
        path: routes.uploadDataManagement,
      },
      {
        title: 'Curriculum Planning',
        icon: <DsIcon icon="PLANNING" />,
        path: routes.curriculumPlanning,
      },
      {
        title: 'School Structure Setup',
        icon: <DsIcon icon="SETTING" />,
        path: routes.schoolStructureSetup,
      },
      {
        title: 'Teachers Management',
        icon: <DsIcon icon="USER" />,
        path: routes.teachersManagement,
      },
      {
        title: 'Rules & Preferences',
        icon: <DsIcon icon="PROJECT" />,
        path: routes.timetableRulesPreferences,
      },
      {
        title: 'Generation & Management',
        icon: <DsIcon icon="TABLE" />,
        path: routes.timetableGenerationManagement,
      },
    ]);

    return () => {
      setBackPath('');
    };
  }, []);

  useEffect(() => {
    loadModuleNamespace('satV1Zone', [
      { jsonFile: satV1AR, lang: 'ar' },
      { jsonFile: satV1DE, lang: 'de' },
      { jsonFile: satV1EN, lang: 'en' },
    ]);
  }, []);

  return <ZoneRoutes />;
};
export default SatV1Zone;
